import API from '@wetransfer/transfer/api';
import ActionHelper from '@wetransfer/transfer/modules/redux-actions';
import Notification from '@wetransfer/transfer/store/action/notification';
import Pending from '@wetransfer/transfer/store/action/pending';

export const actions = ActionHelper.types(['GET_INVOICES']);

export default ActionHelper.generate({
  getInvoices() {
    const pendingId = 'getInvoices';

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        const response = await API.Invoices.getInvoices();

        dispatch({
          type: actions.GET_INVOICES,
          details: response.body,
        });
      } catch (error) {
        dispatch(
          Notification.setNotification('error', 'invoices_retrieve_exception')
        );
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  getInvoice(id) {
    const pendingId = 'getInvoice';

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        const response = await API.Invoices.getHostedInvoice(null, {
          pathExtValues: {
            invoiceId: id,
          },
        });

        if (!response.body.url && !response.body.hosted_invoice_url) {
          throw new Error('invoice_download_exception');
        }

        const newWindow = window.open(
          response.body.hosted_invoice_url,
          '_blank',
          'noopener,noreferrer'
        );
        if (newWindow) newWindow.opener = null;
      } catch (error) {
        dispatch(
          Notification.setNotification('error', 'invoice_download_exception')
        );
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },
});
